import { render, staticRenderFns } from "./privileges.vue?vue&type=template&id=9df08172&scoped=true&"
import script from "./privileges.vue?vue&type=script&lang=js&"
export * from "./privileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df08172",
  null
  
)

export default component.exports